import { SortingState } from '@tanstack/react-table';
import { useState } from 'react';

// Tracks the sorting state of a StateTable, as well as returning the `order` &
// `orderBy` fields to be passed to an API call.
export function useTableSorting<K extends string, T extends string | undefined>(
  defaultSort: { id: K; desc: boolean },
  sortFieldMap: Record<K, T>
) {
  const [sorting, setSorting] = useState<SortingState>([defaultSort]);

  const orderBy = sortFieldMap[(sorting[0]?.id as K) ?? defaultSort.id];
  const order = sorting[0]?.desc ? 'desc' : 'asc';

  return {
    sorting,
    setSorting,
    orderBy,
    order,
  } as const;
}
